import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';

@Component({
  selector: 'app-wbs-tag',
  templateUrl: './wbs-tag.component.html',
  styleUrls: ['./wbs-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioTooltipDirective, TranslatePipe]
})
export class WbsTagComponent {
  readonly tag = input<string>(undefined);
  readonly disableTooltip = input<boolean>(undefined);
  readonly enableUpperCase = input<boolean>(true);
}
